interface Props {
  embedId?: string | null;
}

export default function MinisiteVideo({ embedId }: Props) {
  if (!embedId) return null;

  return (
    <div className="rounded-2xl overflow-hidden">
      <div className="aspect-video bg-black">
        <iframe
          src={`https://www.youtube.com/embed/${embedId}`}
          className="h-full w-full"
          title="Video YouTube"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
}
